import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // console.log("UserRoles controller connected")
  }

  // Auto-submit form when role filter changes
  submitOnChange(event) {
    event.target.form.requestSubmit()
  }
}